<template>
    <div>
        <LsInputLabel
            v-if="label || subLabel || collapseContent"
            :label="label"
            :sub-label="subLabel"
            :collapse-content="collapseContent"
            :error="getValidation.invalid"
        />
        <BField :type="{ 'is-error': getValidation.invalid }">
            <BSelect
                v-model="localValue"
                v-validate="validation"
                :placeholder="placeholder"
                test-id="ls-select"
                :disabled="disabled"
                :name="name"
            >
                <option
                    v-for="option in options"
                    :key="option.label"
                    :value="option.value"
                    :disabled="option.disabled"
                    >{{ option.label }}</option
                >
            </BSelect>
        </BField>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsPropTypeHelpers, lsTrackingService, lsValidationService } from 'ls-vue-common';
import _ from 'lodash';
import LsInputLabel from '../LsInputLabel/LsInputLabel.vue';

export default {
    name: 'LsSelect',
    inject: ['$validator'],
    components: {
        LsInputLabel,
    },
    props: {
        value: VueTypes.any.isRequired,
        trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
        name: VueTypes.string.isRequired,
        options: VueTypes.arrayOf(
            VueTypes.shape({
                label: VueTypes.string.isRequired,
                value: VueTypes.any.isRequired,
                disabled: VueTypes.bool,
            })
        ).isRequired.loose, //TODO2: need loose for now to fix test errors for ChangeFrequncyModal
        label: VueTypes.string,
        subLabel: VueTypes.string,
        collapseContent: VueTypes.string,
        // value prop must initialize as null for placeholder to show
        placeholder: VueTypes.string.def('- Select -'),
        disabled: VueTypes.bool.def(false),
        validation: VueTypes.object.def(_.constant(null)),
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                lsTrackingService.track({
                    event: 'click',
                    target: this.trackId,
                    data: { value },
                });
                this.$emit('input', value);
            },
        },
        getValidation() {
            return lsValidationService.getValidation.call(this);
        },
    },
};
</script>

<style lang="scss">
.select {
    display: flex;
    select {
        border-radius: $border-radius;
        border-color: #e2e5ec;
        width: 100%;
        height: 36px;
    }

    select:focus {
        border-color: inherit;
        box-shadow: 0 0 0 0.125em rgba(226, 229, 236, 0.25);
    }

    &:not(.is-multiple):not(.is-loading)::after {
        border-color: #a0a8c5;
        top: 1.3em;
    }
}

.select.is-error:not(:hover)::after {
    border-color: $red;
}
</style>
